export default "__VITE_ASSET__BUUGGw$n__"